import { createContext, useState } from "react";

export const MapContext = createContext({
    selectedMaps: {},
    totalPrice: "",
    totalSelectedMaps: 0,
    showMapModal: false,
    mapError: false,
    csvFile: "",
    mapDataFromCSV: [],
    dataFromCSVFile: false,
    email: '',
    setShowTotal: false,
    verifiedEmail: false
});

export const MapProvider = ({ children }) => {
    const [selectedMaps, setSelectedMaps] = useState({});
    const [email, setEmail] = useState("")
    const [showTotal, setShowTotal] = useState(false)
    const [verifiedEmail, setVerifiedEmail] = useState(false)
    const [mapDataFromCSV, setMapDataFromCSV] = useState([])
    const [dataFromCSVFile, setDataFromCSVFile] = useState(false)
    const [showMapModal, setShowMapModal] = useState(false)
    const [csvFile, setCsvFile] = useState('')
    const [mapError, setMapError] = useState(false)
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalSelectedMaps, setTotalSelectedMaps] = useState(0)
    const value = { selectedMaps, setSelectedMaps, totalPrice, setTotalPrice, totalSelectedMaps, setTotalSelectedMaps, showMapModal, setShowMapModal, mapError, setMapError, csvFile, setCsvFile, mapDataFromCSV, setMapDataFromCSV, dataFromCSVFile, setDataFromCSVFile, email, setEmail, verifiedEmail, setVerifiedEmail, showTotal, setShowTotal };
    return <MapContext.Provider value={value}>{children}</MapContext.Provider>
}